import { z } from "zod";

/**
 * ZOD'UN ÇALIŞMA ANINDA KOD ÜRETMESİ KAPALI — İçerik Güvenliği Politikası yüzünden, ve bedelsiz.
 *
 * Zod 4, nesne şemalarını hızlandırmak için `new Function` ile kod üretmeyi deniyor; denemeden önce
 * `Function("")` çağırıp ortamın buna izin verip vermediğini YOKLUYOR. Politika `script-src 'self'`
 * (`'unsafe-eval'` yok): yoklama düşüyor, zod yavaş ama doğru yola geçiyor — fakat tarayıcı
 * yoklamanın KENDİSİNİ ihlal olarak raporluyor. Ölçüldü (18 Eylül 2026, üretim derlemesi): her sayfa
 * açılışında bir `securitypolicyviolation`, `script-src ← eval`, kaynak `vendor-forms`. Yayında bu,
 * her kullanıcının her açılışının rapor uç noktasına bir satır yazması demekti — gerçek bir ihlali
 * bu gürültünün içinde görmek imkânsız olurdu.
 *
 * `jitless` yoklamayı hiç yapmıyor. Bedeli yok: CSP altında hızlı yol zaten çalışamıyordu.
 *
 * ZOD'LA AYRIŞTIRAN HER ŞEYDEN ÖNCE yüklenmeli (`env.ts` modül yüklenirken ayrıştırıyor) — o yüzden
 * `main.tsx`'in ve tezgahın (`src/dev/onizleme.tsx`) İLK içe aktarımı.
 */
z.config({ jitless: true });
